<script>

    export default {
        name: 'widget-click-menu',
        props: {
            name: String
        },
        data () {
            return {
                data: {
                    text: '',
                    word: '',
                    color: ''
                },
                extra: {}
            };
        },
        methods: {
            bindEvent () {
                this.$bus.$on('show:tips', (name, target, data) => {
                    if (this.name === name) {
                        this.data = data;
                        this.show(target);
                    }
                });
                this.$bus.$on('hide:tips', (name) => {
                    this.name === name && this.hide();
                });
                document.addEventListener('click', () => {
                    this.hide();
                });
            },
            show (target) {
                this.extra.target = target;

                const elRect = target.getBoundingClientRect();
                const optsRect = this.$el.getBoundingClientRect();

                const {width: elWidth, left: elLeft, right: elRight, top: elTop, height: elHeight} = elRect;
                const {width: optsWidth} = optsRect;

                this.$el.style.top = `${elHeight + window.pageYOffset + elTop}px`;
                if (optsWidth < elWidth) {
                    this.$el.style.left = `${elLeft + window.pageXOffset}px`;
                } else {
                    this.$el.style.left = `${elRight}px`;
                }
                this.extra.status = 'show';
                this.$el.style.opacity = 1;
            },
            hide () {
                if (this.extra.status === 'hide') {
                    return;
                }
                this.extra.target = null;
                this.extra.status = 'hide';
                this.$el.style.opacity = 0;
                setTimeout(() => {
                    this.$el.style.right = 'unset';
                    this.$el.style.left = '-9999px';
                }, 200);
            },
            offEvent () {
                this.$bus.$off('show:tips');
                this.$bus.$off('hide:tips');
            },
        },
        components: {},
        beforeDestroy () {
            this.offEvent();
            document.body.removeChild(this.$el);
        },
        mounted () {
            document.body.appendChild(this.$el);
            this.offEvent();
            this.bindEvent();
        }
    };
</script>

<template>
    <div class="widget-wrapper">
        <div class="widget-popup-tips">
            <p :style="{color: data.color}">{{data.word}}</p>
            <p style="margin: 0">{{data.text}}</p>
        </div>
    </div>
</template>

<style lang="less">
    .widget-wrapper {
        z-index: 99999;
    }

    .widget-popup-tips {
        width: 150px;
        font-size: 14px;
        box-sizing: border-box;
        padding: 15px;

        p {
            margin: 0;
        }
    }
</style>
